import React, { ElementRef, useRef } from "react";
import { DragSourceMonitor } from "react-dnd";
import styled from "styled-components";

import { Stem } from "@examspark/types";

import { useDrag } from "../../hooks/useDnd";

import { DndItem } from "./Token";

const Styled = styled.img`
  cursor: move;
  border: 1px solid transparent;

  &:hover {
    border: 1px solid #aaa;
    background-color: rgba(255, 255, 255, 0.5);
  }
`;

type GraphicTokenProps = {
  data: Stem.Token;
  useDragType: string;
  onEnd?: (item: DndItem | undefined, monitor: DragSourceMonitor) => void;
};
const GraphicToken = (props: GraphicTokenProps) => {
  const ref = useRef<ElementRef<"img">>(null);

  useDrag(ref, {
    item: {
      type: props.useDragType,
      id: props.data.id,
    },
    end: (item, monitor) => {
      props.onEnd?.(item, monitor);
    },
  });

  return (
    <Styled
      ref={ref}
      title={props.data.metadata.alt}
      src={props.data.src}
      width={props.data.metadata.width}
      height={props.data.metadata.height}
      className="item-player-img-token"
    />
  );
};
export default GraphicToken;
